import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { getPaymentStatus } from "@/lib/api";
import { hasPendingReport } from "@/lib/pendingReport";
import { useI18n } from "@/i18n";
import { FullScreen } from "@/components/FullScreen";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useI18n();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const sessionId = params.get("session_id");
    // `resumeReport` dice a ScreeningApp di riprendere il referto lasciato in sospeso e di
    // avviarne subito il download: chi ha pagato a metà lavoro deve ritrovare il proprio
    // lavoro, non un wizard vuoto. Stripe rimanda sull'origin corretto, quindi il
    // sessionStorage sopravvive al giro di pagamento.
    const back = (state) => navigate("/app", state ? { state } : undefined);
    if (!sessionId) { back(); return; }

    const poll = async (attempt = 0) => {
      try {
        const s = await getPaymentStatus(sessionId);
        if (s.payment_status === "paid") {
          toast.success(t("pay_success"));
          // `resumeReport` solo se un referto in sospeso esiste davvero. Con il muro
          // all'avvio di un nuovo screening si paga anche *prima* di compilare: annunciare
          // una ripresa che non può avvenire farebbe comparire "Ricompila lo screening" a
          // chi non aveva nulla da ricompilare.
          back(hasPendingReport() ? { resumeReport: true } : undefined);
          return;
        }
        if (s.status === "expired" || s.payment_status === "failed") { toast.error(t("pay_failed")); back(); return; }
      } catch { /* transient */ }
      if (attempt >= 15) { toast.error(t("pay_timeout")); back(); return; }
      setTimeout(() => poll(attempt + 1), 2000);
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, navigate]);

  return <FullScreen text={t("pay_verifying")} />;
}
